// Angular
import { Component, inject, OnInit, Signal, ChangeDetectionStrategy } from '@angular/core';
// Utils
import { NotificationService } from '../../../utils';

@Component({
  selector: 'app-error-notification-banner',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './error-notification-banner.component.html',
})
export class ErrorNotificationBannerComponent implements OnInit {
  public errorMessage: Signal<string | null>;
  private notificationService = inject(NotificationService);

  /**
   * On Init
   * @memberof ErrorNotificationBannerComponent
   */
  ngOnInit(): void {
    this.errorMessage = this.notificationService.errorMessage;
  }

  /**
   * Closes the error notification.
   * @memberof ErrorNotificationBannerComponent
   */
  onClose(): void {
    this.notificationService.hideError();
  }
}
